import { Paginated } from "../../common/types";
import { Dam } from "./types";

export const DocumentSenasaConvertResponse = (res: Paginated<Dam>) => {
  const data_document = res.dams.map((dam) => {
    const restrictedCodes = (dam.senasa_restricted_tariff ?? "")
      .trim()
      .split(",")
      .filter(Boolean);
    return {
      id: dam.dam_num,
      consigneeName: dam.consignee_name,
      agentName: dam.customs_agency_name,
      uploadDate: dam.senasa_uploaded_at,
      additionalInfo: dam.senasa_comment,
      documents: dam.senasa_docs.object_keys
        ? dam.senasa_docs.object_keys
        : false,
      documentType: "Senasa",
      typeDocumentValidate: "senasa",
      patchInfo: {
        endpoint: `/dams/senasa-admin/${dam.dam_num}/`,
        bodyField: "senasa_status_option",
        comment: "senasa_comment",
      },
      volantes: dam.volantes,
      status: dam.senasa_status.option,
      damNum: dam.dam_num,
      restrictedCodes,
    };
  });

  return {
    data_document,
    type: "senasa",
    numPages: res.num_pages,
    page: res.count,
    count: res.count,
    pageSize: res.page_size,
  };
};
export const DocumentElectronicMandateConvertResponse = (res: any) => {
  const data_document = res.dams.map((dam: any) => {
    return {
      id: dam.dam_num,
      consigneeName: dam.consignee_name,
      agentName: dam.customs_agency_name,
      uploadDate: dam.electronic_mandate_uploaded_at,
      documents: [dam.electronic_mandate_doc],
      documentType: "Mandato electrónico",
      typeDocumentValidate: "electronic_mandate",
      patchInfo: {
        endpoint: `/dams/electronic-mandate-admin/${dam.dam_num}/`,
        bodyField: "electronic_mandate_status_option",
        comment: "electronic_mandate_rejected_comment",
      },
      volantes: dam.volantes,
      status: dam.electronic_mandate_status.option,
      damNum: dam.dam_num,
    };
  });

  return {
    data_document,
    numPages: res.num_pages,
    page: res.page,
    count: res.count,
    pageSize: res.page_size,
  };
};
export const DocumenThirdPartyBillingConvertResponse = (res: any) => {
  const data_document = res.volantes.map((volante: any) => {
    return {
      id: volante.volante_num,
      consigneeName: volante.consignee_name,
      agentName: volante.dam.customs_agency_name,
      uploadDate: volante.third_party_auth_uploaded_at,
      documents: [volante.third_party_billing_authorization_doc],
      documentType: "Facturación a terceros",
      typeDocumentValidate: "third_party",
      patchInfo: {
        endpoint: `/volantes/third-party-billing-authorization/${volante.volante_num}/`,
        bodyField: "third_party_billing_authorization_status_option",
        comment: "third_party_auth_rejected_comment",
      },
      masterAirWaybill: volante.master_air_waybill,
      houseAirWaybill: volante.house_air_waybill,
      damNum: volante.dam.dam_num,
      volantes: volante.volantes,
      status: volante.third_party_billing_authorization_status.option,
      emailThird: volante.third_party_audited_email,
      commentThird: volante.third_party_auth_rejected_comment,
    };
  });

  return {
    data_document,
    numPages: res.num_pages,
    page: res.page,
    count: res.count,
    pageSize: res.page_size,
  };
};
export const DocumenCreditAuthConvertResponse = (res: any) => {
  const data_document = res.invoices.map((invoice: any) => {
    return {
      id: invoice.invoice_id,
      consigneeName: invoice.credit_payment_detail.payer_ruc.name,
      ruc: invoice.credit_payment_detail.payer_ruc.ruc,
      agentName: invoice.agent_name,
      idPayment: invoice.invoice_num,
      uploadDate: invoice.credit_auth_uploaded_at,
      documents: [invoice.credit_auth_doc],
      documentType: "Crédito del importador",
      quotations: invoice.quotations,
      paymentStatusOption: invoice.payment_status.option,
      salesInvoiceTotal: invoice.sales_invoice_total,
      payerRucOption: "consignee",
      patchInfo: {
        endpoint: `/invoices/payment-status/${invoice.invoice_id}/admin/`,
        paymenStatus: "payment_status_option",
        comment: "invoice_rejected_comment",
        rucOption: "payer_ruc_option",
      },
      status: invoice.payment_status_deadline.option,
      volantes: invoice.volantes_by_invoice,
    };
  });

  return {
    data_document,
    type: "consignee",
    numPages: res.num_pages,
    page: res.page,
    count: res.count,
    pageSize: res.page_size,
  };
};
export const DocumenCargoAgentConvertResponse = (res: any) => {
  const data_document = res.invoices.map((invoice: any) => {
    return {
      id: invoice.invoice_id,
      consigneeName: invoice.credit_payment_detail.payer_ruc.name,
      ruc: invoice.credit_payment_detail.payer_ruc.ruc,
      agentName: invoice.agent_name,
      idPayment: invoice.invoice_num,
      uploadDate: invoice.credit_auth_uploaded_at,
      documents: [invoice.credit_auth_doc],
      documentType: "Agente Carga",
      quotations: invoice.quotations,
      paymentStatusOption: invoice.payment_status.option,
      payerRucOption: "cargo_agent",
      patchInfo: {
        endpoint: `/invoices/payment-status/${invoice.invoice_id}/admin/`,
        paymenStatus: "payment_status_option",
        comment: "invoice_rejected_comment",
        rucOption: "payer_ruc_option",
        creditAuthDoc: "credit_auth_doc",
      },
      salesInvoiceTotal: invoice.sales_invoice_total,
      status: invoice.payment_status_deadline.option,
      volantes: invoice.volantes_by_invoice,
    };
  });
  return {
    data_document,
    type: "cargo_agent",
    numPages: res.num_pages,
    page: res.page,
    count: res.count,
    pageSize: res.page_size,
  };
};

export const DocumenThirdPartyAgentConvertResponse = (res: any) => {
  const data_document = res.invoices.map((invoice: any) => {
    return {
      id: invoice.invoice_id,
      consigneeName: invoice.credit_payment_detail.payer_ruc.name,
      ruc: invoice.credit_payment_detail.payer_ruc.ruc,
      agentName: invoice.agent_name,
      idPayment: invoice.invoice_num,
      uploadDate: invoice.credit_auth_uploaded_at,
      documents: [invoice.credit_auth_doc],
      documentType: "Crédito de Tercero",
      quotations: invoice.quotations,
      paymentStatusOption: invoice.payment_status.option,
      payerRucOption: "third_party_agency",
      patchInfo: {
        endpoint: `/invoices/payment-status/${invoice.invoice_id}/admin/`,
        paymenStatus: "payment_status_option",
        comment: "invoice_rejected_comment",
        rucOption: "payer_ruc_option",
        creditAuthDoc: "credit_auth_doc",
      },
      salesInvoiceTotal: invoice.sales_invoice_total,
      status: invoice.payment_status_deadline.option,
      volantes: invoice.volantes_by_invoice,
    };
  });
  return {
    data_document,
    type: "third_party_agency",
    numPages: res.num_pages,
    page: res.page,
    count: res.count,
    pageSize: res.page_size,
  };
};
